// extracted by mini-css-extract-plugin
export var bottomDescription = "EmployeeWellbeing-module--bottomDescription--O8-XY";
export var bottomIconImage = "EmployeeWellbeing-module--bottomIconImage--pub+F";
export var bottomSection = "EmployeeWellbeing-module--bottomSection--UyVny";
export var bottomStatCard = "EmployeeWellbeing-module--bottomStatCard--o6VCF";
export var bottomStatIcon = "EmployeeWellbeing-module--bottomStatIcon--o0Nbo";
export var bottomStatTitle = "EmployeeWellbeing-module--bottomStatTitle--gQ4Cx";
export var bottomStatsGrid = "EmployeeWellbeing-module--bottomStatsGrid--kL9fh";
export var bottomTitle = "EmployeeWellbeing-module--bottomTitle--Y1N50";
export var employeeWellbeingWrapper = "EmployeeWellbeing-module--employeeWellbeingWrapper--9P0M8";
export var headerSection = "EmployeeWellbeing-module--headerSection--7HW7c";
export var iconImage = "EmployeeWellbeing-module--iconImage--5c7LP";
export var indiaMap = "EmployeeWellbeing-module--indiaMap--t+vAW";
export var mainDescription = "EmployeeWellbeing-module--mainDescription--WwIqm";
export var mainTitle = "EmployeeWellbeing-module--mainTitle--rKOsx";
export var mapContainer = "EmployeeWellbeing-module--mapContainer--jQgH6";
export var statCard = "EmployeeWellbeing-module--statCard--JTh96";
export var statIcon = "EmployeeWellbeing-module--statIcon--WTNhH";
export var statText = "EmployeeWellbeing-module--statText--gqS8P";
export var statsContainer = "EmployeeWellbeing-module--statsContainer--N6kl9";